import { ANDROID_PACKAGE } from '../enum/Constants';
import { firebaseInit } from './firebase';
import { closeDialog, isIOS, openDialog } from './utils';
import '@/src/styles/pages/_join_pc.scss';
import '@/src/styles/base/_common.scss';
const goAppLink = () => {
    if (isIOS()) {
        openDialog('iOS 앱은 준비중입니다.', closeDialog);
    }
    else {
        window.open(`https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`);
    }
};
const handleClickWeb = () => {
    openDialog('V 컬러링 웹 버전은 모바일에서만 이용하실 수 있습니다.\n모바일에서 https://www.vcoloring.com으로 접속하세요', closeDialog);
};
const initialize = () => {
    firebaseInit();
    const btn = document.getElementById('download-btn');
    const web = document.getElementById('web-btn');
    if (btn) {
        btn.addEventListener('click', goAppLink);
    }
    if (web) {
        web.addEventListener('click', handleClickWeb);
    }
};
initialize();
